import { Injectable } from '@angular/core';
import { Invoice } from '../../domain/models/invoice.model';
import { InvoiceDto } from '../dtos/invoice.dto';

function toPaymentStatus(value: string): 'pending' | 'paid' {
  return value === 'paid' ? 'paid' : 'pending';
}

@Injectable()
export class InvoiceMapper {
  public toInvoice(dto: InvoiceDto): Invoice {
    return {
      externalId: dto.ExternalId,
      externalUrl: dto.ExternalUrl,
      invoiceNumber: dto.InvoiceNumber,
      invoicePrefix: dto.InvoicePrefix,
      status: dto.Status,
      clientId: dto.ClientId,
      patientIds: dto.PatientIds ?? [],
      patientNames: dto.PatientNames ?? [],
      consultationId: dto.ConsultationId,
      consultationDate: dto.ConsultationDate,
      consultationReason: dto.ConsultationReason,
      departmentId: dto.DepartmentId,
      departmentName: dto.DepartmentName,
      total: dto.Total,
      totalVat: dto.TotalVat,
      totalWithVat: dto.TotalWithVat,
      dueSum: dto.DueSum,
      clientDueSum: dto.ClientDueSum,
      payerName: dto.PayerName,
      payerIdNumber: dto.PayerIdNumber,
      payerAddress: dto.PayerAddress,
      invoiceDate: dto.InvoiceDate,
      invoiceDueDate: dto.InvoiceDueDate,
      datePaid: dto.DatePaid,
      remarks: dto.Remarks,
      internalRemarks: dto.InternalRemarks,
      isCreditNote: dto.IsCreditNote,
      creditNoteOriginalInvoiceId: dto.CreditNoteOriginalInvoiceId,
      createdAtUtc: dto.Created,
      modifiedAtUtc: dto.Modified,
      isPending: dto.IsPending,
      paymentStatus: toPaymentStatus(dto.PaymentStatus),
      isOverdue: dto.IsOverdue ?? false,
      hasPdf: true,
    };
  }
}
